module.exports = __webpack_public_path__ + "img/img48.096dd462.svg";